export default "__VITE_ASSET__CbCydMdg__"